import { RiskLevel } from "@/model/RiskLevel";
import DudleyLogo from "@/assets/regions/change-grow-live-logo-512px.png";
const DudleyBanner = {
    rawCopy: "For alcohol advice and support in Dudley, call Atlantic Recovery Community\n" +
        "Service (provided by Change Grow Live) on 01384 426 120",
    logoLink: "https://changegrowlive.org/dudley/info"
};
export default {
    name: "Dudley",
    logo: {
        file: DudleyLogo,
        width: 515,
        height: 203
    },
    zoomLevel: 10,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: DudleyBanner,
        [RiskLevel.Lower]: DudleyBanner,
        [RiskLevel.Increasing]: DudleyBanner,
        [RiskLevel.Higher]: DudleyBanner,
        [RiskLevel.High]: DudleyBanner
    },
    clinics: [
        {
            name: "Atlantic Recovery Community Service (provided by Change Grow Live)",
            isPrimaryProvider: true,
            description: "Contact ${name} on ${phone}",
            phone: ["01384 426 120"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 2000 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
            other_info: "For more information <a href='https://changegrowlive.org/dudley/info' target='_blank'>click here</a><br><br>",
            location: { lat: 52.463122, lng: -2.1155191 },
            address: "Atlantic Recovery Centre, Dudley Road, Lye, DY9 8EL",
            website: "https://changegrowlive.org/dudley/referrals"
        }
    ]
};
//# sourceMappingURL=Dudley.js.map